import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../root-store';
import { DocumentsAreaCommonState } from './common-types';

export const selectDocumentsAreaCommonState = (
  state: RootState
): DocumentsAreaCommonState => state.features.documents.common;

export const getSelectedDocumentsSection:any = createDraftSafeSelector(
  selectDocumentsAreaCommonState,
  (state: DocumentsAreaCommonState) => {
    return state.selectedSection;
  }
);

export const getTotalUnreadCounts:any = createDraftSafeSelector(
  selectDocumentsAreaCommonState,
  (state: DocumentsAreaCommonState) => state.totalUnreadCounts
);

export const getNavigationMustReset:any = createDraftSafeSelector(
  selectDocumentsAreaCommonState,
  (state: DocumentsAreaCommonState) => state.navigationMustReset
);

export const getMarkDocumentAsRead:any = createDraftSafeSelector(
  selectDocumentsAreaCommonState,
  (state: DocumentsAreaCommonState) => state.markDocumentAsReadRequestStatus
);
